import AddIcon from '@mui/icons-material/Add';
import { Grid, IconButton, Switch } from '@mui/material';
import { useEffect, useState } from 'react';
import { FaRegEdit } from 'react-icons/fa';
import { getLeadStatusList, saveLeadStatus, LeadStatusDTO } from 'wisestep-api';
import { WsButton, WsDataTable } from 'wisestep-base';

import { SettingsPageLayout } from '../../../../components/SettingsPageLayout';

import LeadStatusForm from './LeadStatusForm';

const LeadStatus = () => {
  const [leadStatusList, setLeadStatusList] = useState<LeadStatusDTO[]>([]);
  const [dialogDefaultValues, setDialogDefaultValues] = useState<any>(null);
  const [flag, setFlag] = useState<boolean>(false);
  const [open, setOpen] = useState<boolean>(false);

  const fetchAll = async () => {
    const response = await getLeadStatusList();
    setLeadStatusList(response.data ?? []);
  };

  useEffect(() => {
    const fetchData = async () => {
      await fetchAll();
    };

    fetchData();
  }, [flag]);

  const onSave = () => {
    setFlag(true);
    fetchAll();
    setOpen(false);
  };

  const openLeadStatusFormDialog = (defaultValues?: any) => {
    setDialogDefaultValues(defaultValues || null);
    setOpen(true);
  };

  const handleCancel = () => setOpen(false);

  const sortedData = [...leadStatusList].sort(
    (a, b) => new Date(a.createdOn).getTime() - new Date(b.createdOn).getTime()
  );

  const columns = [
    {
      Header: 'Lead Status',
      accessor: 'leadStatusName',
    },
    {
      Header: 'Visibility',
      accessor: 'visibility',
      Cell: (props) => {
        const row = props.row.original;
        return (
          <Switch
            readOnly
            defaultChecked={row.visibility}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
              saveLeadStatus({ ...row, visibility: event.target.checked }).then(fetchAll)
            }
          />
        );
      },
    },
    {
      Header: 'Is Default Status',
      accessor: 'makeDefaultStatus',
      Cell: (props) => (props.row.original.makeDefaultStatus ? 'Yes' : 'No'),
    },
    {
      Header: 'Created By',
      accessor: 'createdByName',
    },
    {
      Header: '',
      accessor: 'edit',
      Cell: (props) => {
        const row = props.row.original;
        return (
          <IconButton onClick={() => openLeadStatusFormDialog(row)}>
            <FaRegEdit />
          </IconButton>
        );
      },
    },
  ];

  return (
    <SettingsPageLayout
      title="Lead Status"
      indexOptions={[{ label: 'Lead Status', url: '/lead-status' }]}
      backUrl={'/app-settings/leads'}
    >
      <Grid direction="row" p={2} justifyContent="flex-end" alignItems="center" display="flex">
        <WsButton
          startIcon={<AddIcon />}
          variant="outlined"
          onClick={() => openLeadStatusFormDialog()}
        >
          Add Lead Status
        </WsButton>
      </Grid>
      <WsDataTable dense columns={columns} data={sortedData} />
      <LeadStatusForm
        open={open}
        onSave={onSave}
        onCancel={handleCancel}
        leadStatusList={leadStatusList}
        {...(dialogDefaultValues && { defaultValues: dialogDefaultValues })}
      />
    </SettingsPageLayout>
  );
};

export default LeadStatus;
